document.addEventListener('DOMContentLoaded', () => {
  // Hier das gesamte CSS für den Chat (Button, Fenster, Texte, etc.) einfügen
  const customCss = `
    button.activator {
      background-color: white !important;
      &:hover {
        background-color: #d8ceb3 !important;
      }
    }
    section.panel {
      background-color: rgba(255, 255, 255, 1) !important;
    }
  `;

  function injectStyleRecursively(root) {
    if (!root) return;

    // Das Style-Element in JEDEN Shadow-Root injizieren
    if (!root.querySelector('#ks-chat-custom-styles')) {
      const style = document.createElement('style');
      style.id = 'ks-chat-custom-styles';
      style.textContent = customCss;
      root.appendChild(style);
    }

    // Alle Elemente im aktuellen Root nach weiteren Shadow-Roots durchsuchen
    root.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot) {
        injectStyleRecursively(el.shadowRoot);
      }
    });
  }

  // Sucht permanent nach neuen Shadow-Roots (z.B. beim Öffnen des Chats)
  setInterval(() => {
    const chatHost = document.querySelector('shopify-chat');
    if (chatHost && chatHost.shadowRoot) {
      injectStyleRecursively(chatHost.shadowRoot);
    }
  }, 1000);
});